package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class PatientTreatment(
    val id: Int,
    val appointment_id: Int? = null,
    val diagnosis_id: Int? = null,
    val diagnosis: Diagnosis? = null,
    val diagnosis_type_id: Int? = null,
    val diagnosis_type: DiagnosisType? = null,
    val tooth_number: Int? = null,
    val teeth: List<Int> = emptyList(),
    val is_finished: Int? = null,
    val final_diagnosis_id: Int? = null,
    val created_at: String? = null
)

@Serializable
data class Diagnosis(
    val id: Int,
    val name: String? = null,
    val code: String? = null,
    val organization_id: Int? = null,
    val deleted_at: String? = null,
    val created_at: String? = null,
    val updated_at: String? = null
)

@Serializable
data class DiagnosisType(
    val id: Int,
    val name: String? = null
)
